// Scroll Magic
function scrolltime() {
    //DEV MODE
    var DEVMODE = false;
    //Scroll Magic Controller
    var sm_cont = new ScrollMagic.Controller({});
    //Overview Section
    var tl = new TimelineMax({}),
        anim_time = 0.3,
        delay_time = 0.05;
    tl.add([
        TweenMax.staggerFromTo("#overview .bg", anim_time, { opacity: "0.3" }, { opacity: "1" }, delay_time),
        TweenMax.staggerFromTo("#overview .bg-mobile", anim_time, { opacity: "0.3" }, { opacity: "1" }, delay_time),
        TweenMax.staggerFromTo("#overview .logo", anim_time, { top: "10px", opacity: "0" }, { top: "0px", opacity: "1", delay: 0.1 }, delay_time),
        TweenMax.staggerFromTo("#overview .title", anim_time, { top: "10px", opacity: "0" }, { top: "0px", opacity: "1", delay: 0.2 }, delay_time),
        TweenMax.staggerFromTo("#overview .title-img", anim_time, { top: "10px", opacity: "0" }, { top: "0px", opacity: "1", delay: 0.2 }, delay_time),
        TweenMax.staggerFromTo("#overview .content span", anim_time, { top: "10px", opacity: "0" }, { top: "0px", opacity: "1", delay: 0.3 }, delay_time),
        TweenMax.staggerFromTo("#overview .logo-secondary", anim_time, { marginLeft: "-5vw", opacity: "0" }, { marginLeft: "0vw", opacity: "1", delay: 0.4 }, delay_time),
        TweenMax.staggerFromTo("#overview .bats-in", anim_time, { bottom: "-15px", opacity: "0" }, { bottom: "0vw", opacity: "1", delay: 0.5 }, delay_time),
        TweenMax.staggerFromTo("#gameplay .bats", anim_time, { top: "55%", opacity: "0" }, { top: "50%", opacity: "1", delay: 0.5 }, delay_time)
    ]);

    var sm_s = new ScrollMagic.Scene({ triggerElement: "#overview", offset: 0 })
        .setTween(tl)
        .addTo(sm_cont);
    //Debug Indicators    
    if (DEVMODE) { sm_s.addIndicators({ name: "Overview", indent: 0, colorStart: "#07ff00", colorEnd: "#ff0000", colorTrigger: "#ff9700" }) };
};
$(document).ready(function() {
    scrolltime();
});